export default __webpack_public_path__ + "static/media/Dsc_Oh.5f33c029.mp3";